import { render, staticRenderFns } from "./VideoPlay.vue?vue&type=template&id=fce0c2bc&scoped=true&"
import script from "./VideoPlay.vue?vue&type=script&lang=js&"
export * from "./VideoPlay.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlay.vue?vue&type=style&index=0&id=fce0c2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce0c2bc",
  null
  
)

export default component.exports